import { Ticket, Zone, LapiControl } from "../../index";

export function getLatestTicket(tickets?: Ticket[]): Ticket | undefined {
  if (tickets === undefined || tickets.length === 0) return;

  const latestTicket = tickets.reduce((accumulator, currentValue) => {
    if (accumulator.endDateTime < currentValue.endDateTime) {
      return currentValue;
    } else {
      return accumulator;
    }
  });

  return latestTicket;
}

export function getTicketDurationInMs(ticket: Ticket): number {
  return (
    new Date(ticket.endDateTime).getTime() -
    new Date(ticket.startDateTime).getTime()
  );
}

export function getTicketDurationInSec(ticket: Ticket): number {
  return getTicketDurationInMs(ticket) / 1000;
}

export function getTicketDurationInMin(ticket: Ticket): number {
  return getTicketDurationInSec(ticket) / 60;
}

export function isTicketInGracePeriod(
  ticket: Ticket,
  zone: Zone,
  lapiControl: LapiControl
): boolean {
  if (ticket.profile === "FPS") return false;

  const gracePeriod = zone.gracePeriod; // In % (example: `0.4`).
  if (gracePeriod === undefined || gracePeriod <= 0) return false;

  const gracePeriodMax = zone.gracePeriodMax; // In minutes.
  if (gracePeriodMax === undefined || gracePeriodMax <= 0) return false;

  const ticketDurationInMin = getTicketDurationInMin(ticket);

  const gracePeriodEffective = Math.min(
    Math.ceil(ticketDurationInMin * gracePeriod),
    gracePeriodMax
  );

  const lapiControlDate = new Date(lapiControl.date);
  const gracePeriodStartDate = new Date(ticket.endDateTime);
  const gracePeriodEndDate = new Date(ticket.endDateTime);
  gracePeriodEndDate.setMinutes(
    gracePeriodEndDate.getMinutes() + gracePeriodEffective
  );

  if (lapiControlDate < gracePeriodStartDate) return false;
  if (lapiControlDate > gracePeriodEndDate) return false;

  return true;
}
